import { sdk } from '@amf/shared/lib/graphQlClient';
import { PlayerTransferFragment } from '@amf/shared/types/graphql';

export const LIMIT = 10;
const API_KEY = `/api/player/transfer`;

export const getCacheKey =
  (playerId: string) => (pageIndex: number, prevPageData: PlayerTransferFragment[] | null) => {
    const params = new URLSearchParams({ offset: `${LIMIT * pageIndex}` });
    if (playerId) params.append('player', playerId);

    if (prevPageData === null || pageIndex === 0) {
      return `${API_KEY}?${params.toString()}`;
    }

    if (prevPageData.length < LIMIT) {
      return null;
    }

    return `${API_KEY}/?${params.toString()}`;
  };

export async function getPlayerTransfers(
  playerId: string,
  offset: number | null = 0,
  limit: number | null = LIMIT,
): Promise<PlayerTransferFragment[]> {
  const { transfers } = await sdk.PlayerTransfers({
    union: process.env.NEXT_PUBLIC_UNION,
    player: playerId,
    offset,
    limit,
  });
  return transfers;
}
